module.exports = __webpack_public_path__ + "img/055-doctor.3bb80993.png";